import { render, staticRenderFns } from "./PopupConfirm.vue?vue&type=template&id=18016a5a&scoped=true&lang=pug&"
import script from "./PopupConfirm.vue?vue&type=script&lang=js&"
export * from "./PopupConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PopupConfirm.vue?vue&type=style&index=0&id=18016a5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18016a5a",
  null
  
)

export default component.exports